exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-checkradio[type=checkbox]:checked+label[data-v-0bf4853e]:before,.is-checkradio[type=radio]:checked+label[data-v-0bf4853e]:before{border:.15rem solid #dbdbdb}.is-checkradio[type=checkbox]+label[data-v-0bf4853e]:after{border-width:.15rem}.fieldUserType[data-v-0bf4853e]{margin-top:20px;margin-bottom:25px}.fieldsub[data-v-0bf4853e]{margin-top:5px;margin-bottom:10px}.fieldsub span[data-v-0bf4853e]{font-weight:700}.mainContent[data-v-0bf4853e]{padding:0 60px}.style-chooser .vs__dropdown-menu[data-v-0bf4853e],.style-chooser .vs__dropdown-toggle[data-v-0bf4853e],.style-chooser .vs__search[data-v-0bf4853e]::placeholder{background:#dfe5fb;border:none;color:#394066;text-transform:lowercase;font-variant:small-caps}.style-chooser .vs__clear[data-v-0bf4853e],.style-chooser .vs__open-indicator[data-v-0bf4853e]{fill:#394066}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0bf4853e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/users/AddUser.vue
// module id = 684
// module chunks = 2